import * as React from "react"
import {formatDate} from "@ui-seeker/utils";
import { Box } from "@mui/material";

import {BORDER_STYLE, BORDER_COLOR} from "@constants";


export default function dateDeliveryColumn(value, label) {
	return [{
		name: value, label: label,
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? `Has ${label}` : `No ${label}`
		}
	} , {
		name: value, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box>
				{!!value ? formatDate(value, { isString: true }) : '--'}
			</Box>
		}
	}]
}
